import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { HEADING_TEXT } from '../itemIds';
import { useEditorStore } from '~/shell/Store';
import { x } from '@xstyled/styled-components';

interface Props {
  title: string;
  bold?: boolean;
  marginBottom: string;
  fontSize: string;
}
export class HeadingText extends Item<typeof HEADING_TEXT, Props> {
  protected render({
    title,
    bold,
    marginBottom = '0px',
    fontSize = '16px'
  }: RenderProps<Props>) {
    const { contentEditable } = useEditorStore();

    if (contentEditable) {
      return (
        <x.div
          fontWeight={bold ? 'bold' : 'normal'}
          mb={marginBottom}
          fontSize={fontSize}
        >
          {title}
        </x.div>
      );
    }

    return <></>;
  }
}

registry[HEADING_TEXT] = HeadingText;
